var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "step",
      attrs: { novalidate: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _vm._l(_vm.schema.rows, function(row) {
        return [
          _c(
            "div",
            { staticClass: "step__row" },
            [
              _vm._l(row, function(item) {
                return [
                  item.heading
                    ? _c("div", { staticClass: "step__title text_x_large" }, [
                        _vm._v(_vm._s(item.heading))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.subheading
                    ? _c(
                        "p",
                        { staticClass: "step__description text_medium" },
                        [_vm._v(_vm._s(item.subheading))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.list
                    ? _c(
                        "ol",
                        { staticClass: "step__list text_medium" },
                        [
                          _vm._l(item.list, function(row) {
                            return [
                              _c("li", { staticClass: "step__list-item" }, [
                                _vm._v(_vm._s(row))
                              ])
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.field === "agreementCheckbox"
                    ? _c(
                        "span",
                        [
                          _c("md-checkbox", {
                            attrs: {
                              name: item.name,
                              id: item.id,
                              errorMessage: _vm.errorMessage("privacy-policy"),
                              required: item.required
                            },
                            model: {
                              value: _vm.form.privacyPolicy,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "privacyPolicy", $$v)
                              },
                              expression: "form.privacyPolicy"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.i18n.kyc_i_agree())
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.field === "text"
                    ? _c("input-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: item.validate,
                            expression: "item.validate"
                          }
                        ],
                        key: item.id,
                        staticClass: "step__input-field",
                        attrs: {
                          name: item.name,
                          id: item.id,
                          required: item.required,
                          label: item.label,
                          type: item.type,
                          errorMessage: _vm.errorMessage(item.name),
                          disabled:
                            _vm.accountState === _vm.ACCOUNT_STATES.pending
                        },
                        model: {
                          value: _vm.form[item.model],
                          callback: function($$v) {
                            _vm.$set(_vm.form, item.model, $$v)
                          },
                          expression: "form[item.model]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.field === "textarea"
                    ? _c("textarea-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: item.validate,
                            expression: "item.validate"
                          }
                        ],
                        key: item.id,
                        staticClass: "step__input-field",
                        attrs: {
                          name: item.name,
                          id: item.id,
                          required: item.required,
                          label: item.label,
                          type: item.type,
                          maxlength: item.maxlength,
                          errorMessage: _vm.errorMessage(item.name),
                          disabled:
                            _vm.accountState === _vm.ACCOUNT_STATES.pending
                        },
                        model: {
                          value: _vm.form[item.model],
                          callback: function($$v) {
                            _vm.$set(_vm.form, item.model, $$v)
                          },
                          expression: "form[item.model]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.field === "file"
                    ? _c("file-field", {
                        key: item.id,
                        staticClass: "step__file-field",
                        attrs: {
                          fileType: item.fileType,
                          private: item.private,
                          label: item.label,
                          type: item.type,
                          id: item.id,
                          disabled:
                            _vm.accountState === _vm.ACCOUNT_STATES.pending
                        },
                        model: {
                          value: _vm.documents[item.type],
                          callback: function($$v) {
                            _vm.$set(_vm.documents, item.type, $$v)
                          },
                          expression: "documents[item.type]"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.field === "vue-select" && _vm.values[item.values].length
                    ? _c(
                        "span",
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.label) + "\n          "
                          ),
                          _c("select-field", {
                            key: item.id,
                            attrs: {
                              name: item.name,
                              id: item.id,
                              label: item.label,
                              values: _vm.values[item.values],
                              options: _vm.values[item.values],
                              disabled:
                                _vm.accountState === _vm.ACCOUNT_STATES.pending
                            },
                            model: {
                              value: _vm.form[item.model],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.model, $$v)
                              },
                              expression: "form[item.model]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.field === "date"
                    ? _c("date-field-flatpickr", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        key: item.id,
                        attrs: {
                          name: item.name,
                          id: item.id,
                          required: item.required,
                          label: item.label,
                          disableAfter: item.disableAfter,
                          disableBefore: item.disableBefore,
                          errorMessage: _vm.errorMessage(item.name),
                          disabled:
                            _vm.accountState === _vm.ACCOUNT_STATES.pending,
                          enableTime: false
                        },
                        model: {
                          value: _vm.form[item.model],
                          callback: function($$v) {
                            _vm.$set(_vm.form, item.model, $$v)
                          },
                          expression: "form[item.model]"
                        }
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap margin-top" },
        [
          _vm.finished
            ? _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  attrs: {
                    type: "submit",
                    disabled:
                      _vm.isPending ||
                      _vm.accountState === _vm.ACCOUNT_STATES.pending ||
                      !_vm.form.privacyPolicy
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_submit()) + "\n    ")]
              )
            : _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  attrs: {
                    type: "submit",
                    disabled:
                      _vm.isPending ||
                      _vm.accountState === _vm.ACCOUNT_STATES.pending
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.i18n.sale_next_step()) + "\n    "
                  )
                ]
              )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e59c5bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e59c5bb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/verification/steps/Step.Default.vue
// module id = Sssu
// module chunks = 1